import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useIntroOutroContext } from '../../context/IntroOutroContext';
import styles from './IntroOutroEditor.module.scss';
import cx from 'classnames';
import Icon from '../Icon/Icon';
import RadioButton from '../RadioButton/RadioButton';

const IntroOutroItem = ({ id, name, intro, outro, handleChoose, allowCheckboxOnEmpty = false }) => {
  const { selectedIntroOutro } = useIntroOutroContext();

  const { t } = useTranslation();

  const cleanUrl = (url) => {
    if (!url) {
      return '';
    }
    const preparedUrl = url
      .replace(/\.s3.*\.amazonaws\.com/i, '')
      .replace('https://', '')
      .replace('s3://', '');
    const decodedUrl = decodeURI(preparedUrl);
    return decodedUrl.split('?')[0];
  }

  const isIntroSelected = useMemo(() => cleanUrl(selectedIntroOutro.intro?.video) === cleanUrl(intro?.video), [selectedIntroOutro, intro]);
  const isOutroSelected = useMemo(() => cleanUrl(selectedIntroOutro.outro?.video) === cleanUrl(outro?.video), [selectedIntroOutro, outro]);

  const isIntroCardClickable = useMemo(() => intro?.video || allowCheckboxOnEmpty, [intro, allowCheckboxOnEmpty]);
  const isOutroCardClickable = useMemo(() => outro?.video || allowCheckboxOnEmpty, [outro, allowCheckboxOnEmpty]);

  return (
    <div className={styles.introOutroItem}>
      {name && <span className={styles.introOutroTitle}>{name}</span>}
      <div
        className={cx(styles.introOutroThumbnailContainer, { [styles.introOutroSelected]: isIntroSelected && isOutroSelected })}
      >
        <div className={cx(styles.thumbnailContainer, { [styles.selected]: isIntroSelected && !isOutroSelected && isIntroCardClickable, [styles.allowHover]: isIntroCardClickable })}>
          {intro?.thumbnail ? (
            <div className={styles.thumbnailWrapper}
              onClick={() =>
                handleChoose(
                  { intro: { id, video: intro?.video, thumbnail: intro?.thumbnail, duration: intro?.duration } },
                  isIntroSelected,
                )
              }>
              <img src={intro?.thumbnail} className={styles.thumbnail} alt={t('my_video.tools.thumbnail')} />
              <RadioButton checked={isIntroSelected} className={styles.radioButton} />
            </div>
          ) : (
            <div className={styles.thumbnailWrapper} onClick={() => handleChoose({ intro }, true)}>
              <Icon src="noIntro" className={styles.icon} />
              <span>{t('my_video.tools.intro_outro.no_intro')}</span>
              {allowCheckboxOnEmpty && <RadioButton checked={!selectedIntroOutro.intro?.video} className={styles.radioButton} />}
            </div>
          )}
        </div>
        <div className={cx(styles.thumbnailContainer, { [styles.selected]: isOutroSelected && !isIntroSelected && isOutroCardClickable, [styles.allowHover]: isOutroCardClickable })}>
          {outro?.thumbnail ? (
            <div className={styles.thumbnailWrapper}
              onClick={() =>
                handleChoose({
                  outro: { id, video: outro?.video, thumbnail: outro?.thumbnail, duration: outro?.duration },
                }, isOutroSelected)
              }
            >
              <img src={outro?.thumbnail} className={styles.thumbnail} alt={t('my_video.tools.thumbnail')} />
              <RadioButton checked={isOutroSelected} className={styles.radioButton} />
            </div>
          ) : (
            <div className={styles.thumbnailWrapper} onClick={() => handleChoose({ outro }, true)}>
              <Icon src="noOutro" className={styles.icon} />
              <span>{t('my_video.tools.intro_outro.no_outro')}</span>
              {allowCheckboxOnEmpty && <RadioButton checked={!selectedIntroOutro.outro?.video} className={styles.radioButton} />}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default IntroOutroItem;
